import { RuleGuestAttributeResourceTypeRelation, RuleResourceTypeGreaterThanEqual } from "../../../shared/types";
import { RelationRuleValidator } from "./types";

export const relationGreaterThanEqual: RelationRuleValidator<
	RuleResourceTypeGreaterThanEqual<RuleGuestAttributeResourceTypeRelation>
> = {
	validate: (rule, value) => {
		if (value == null || rule.value == null) {
			return false;
		}

		switch (rule.guestAttribute.entityType) {
			case "hotelStay.checkIn":
			case "hotelStay.checkOut": {
				const dates = ((Array.isArray(value) ? value : [value]) as string[]).filter((date) => !!date);
				return dates.some((date) => date >= (rule.value as string));
			}
			default:
				throw new Error("Not implemented rule");
		}
	},
};
